import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

import { colors } from "@/theme/tokens/colors";

export const SprengnetterIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon
      viewBox="0 0 34 42"
      sx={{
        width: "34px",
        height: "42px",
      }}
      {...props}
    >
      <svg width="34" height="42" viewBox="0 0 34 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 10.6C1 7.23969 1 5.55953 1.65396 4.27606C2.2292 3.14708 3.14708 2.2292 4.27606 1.65396C5.55953 1 7.23968 1 10.6 1H23.4C26.7603 1 28.4405 1 29.7239 1.65396C30.8529 2.2292 31.7708 3.14708 32.346 4.27606C33 5.55953 33 7.23969 33 10.6V31.4C33 34.7603 33 36.4405 32.346 37.7239C31.7708 38.8529 30.8529 39.7708 29.7239 40.346C28.4405 41 26.7603 41 23.4 41H10.6C7.23968 41 5.55953 41 4.27606 40.346C3.14708 39.7708 2.2292 38.8529 1.65396 37.7239C1 36.4405 1 34.7603 1 31.4V10.6Z"
          stroke={colors.brand.blue}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.4621 8.17366V14.2043H21.9267V9.55568C18.4541 9.49411 15.1773 10.694 12.0745 12.0684V14.2043H10.5391V11.3774C14.2445 8.99659 19.0197 7.70001 23.4621 8.17366Z"
          fill={colors.brand.blue}
        />
        <path
          d="M12.0745 27.8987V29.9089C15.1671 31.2984 18.4592 32.5108 21.9267 32.4216V27.8987H23.4621V33.8036C18.9403 34.3703 14.4684 32.8375 10.5391 30.7883V27.8987H12.0745Z"
          fill={colors.brand.blue}
        />
        <path
          d="M20.1857 19.481C19.8863 19.4194 18.974 19.5765 18.7948 19.4634C18.6899 19.3968 18.6554 18.5274 17.9721 18.1982C16.5032 17.4896 14.7439 18.844 15.8379 19.7913C16.8193 20.6406 19.8875 20.1067 20.2829 22.2111C21.0583 26.3408 13.6819 26.6034 13.6602 22.6219C13.9327 22.6734 15.0715 22.5415 15.1815 22.6357C15.2276 22.6747 15.3363 23.3971 15.6984 23.6974C16.6913 24.5203 19.3501 24.0404 18.681 22.5264C18.1487 21.3241 14.3959 22.0905 14.0555 19.6581C13.5041 15.7244 20.4505 15.6553 20.1857 19.481Z"
          fill={colors.brand.blue}
        />
      </svg>
    </SvgIcon>
  );
};
